import script from "./self-recycling-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./self-recycling-form.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__